import type { TypeOf } from 'io-ts';
import fromEnum from '@/scripts/io-ts/fromEnum';

export const HeavyTaskOutcome = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
} as const;

export const HeavyTaskOutcomeC = fromEnum('HeavyTaskOutcome', HeavyTaskOutcome);

export type HeavyTaskOutcome = TypeOf<typeof HeavyTaskOutcomeC>;
